import axios from "axios";
import qs from "qs";

class FetchClient {
  constructor() {
    this.session = null;
    this._client = axios.create();
  }

  setSession(session) {
    this.session = session;
  }

  async get(url, query, options) {
    return await this._call("GET", url, query, options);
  }

  async post(url, body, options) {
    return await this._call("POST", url, body, options);
  }

  async patch(url, body, options) {
    return await this._call("PATCH", url, body, options);
  }

  async delete(url, body, options) {
    return await this._call("DELETE", url, body, options);
  }

  async put(url, body, options) {
    return await this._call("PUT", url, body, options);
  }

  async sendFile(url, file, options) {
    const formData = new FormData();
    formData.append("data", file);
    options = options || {};
    options.headers = options.headers || {};
    options.headers["Content-Type"] = "multipart/form-data";
    return await this._call("POST", url, formData, options);
  }

  async _call(method, url, data, options = {}) {
    options = this._injectSession(options);

    const requestOptions = {
      method,
      url,
    };
    if (data) {
      if (method === "GET") {
        requestOptions.params = data;
        requestOptions.paramsSerializer = {
          serialize: (params) => {
            return qs.stringify(params);
          },
        };
      } else {
        requestOptions.data = data;
      }
    }
    Object.assign(requestOptions, options);

    return await this._client.request(requestOptions);
  }

  _injectSession(options) {
    if (!this.session) return options;
    if (options?.session === false) return options;

    options.headers = options.headers || {};
    options.headers.authorization = options.headers.authorization || "Bearer " + this.session.token;
    return options;
  }
}

export default new FetchClient();
